export { DisplayMode as DISPLAY_MODE, ModifierKey as MODIFIERS, ToolbarType as TOOLBARS } from 'wix-rich-content-common';

const TEXT_TYPES = Object.freeze([
  "unstyled",
  "blockquote",
  "header-one",
  "header-two",
  "header-three",
  "header-four",
  "header-five",
  "header-six",
  "ordered-list-item",
  "unordered-list-item"
]);
const CHARACTERS = Object.freeze({
  TAB: "	"
});
const KEYS_CHARCODE = {
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
  TAB: 9,
  ARROW_UP: 38,
  ARROW_DOWN: 40,
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39
};
const ALIGN_LEFT = "AlignLeft";
const ALIGN_RIGHT = "AlignRight";
const ALIGN_CENTER = "AlignCenter";
const ALIGN_JUSTIFY = "Justify";
const FORMATTING_BUTTONS = Object.freeze({
  BOLD: "Bold",
  ITALIC: "Italic",
  UNDERLINE: "Underline",
  TITLE: "Title",
  BLOCKQUOTE: "Blockquote",
  ALIGNMENT: "Alignment",
  ALIGN_LEFT,
  ALIGN_RIGHT,
  ALIGN_CENTER,
  ALIGN_JUSTIFY,
  ALIGN_GROUP: {
    tooltipKey: "AlignTextDropdownButton_Tooltip",
    name: "Alignment",
    dataHook: "Alignment",
    buttons: [ALIGN_LEFT, ALIGN_CENTER, ALIGN_RIGHT, ALIGN_JUSTIFY]
  },
  ORDERED_LIST: "OrderedList",
  UNORDERED_LIST: "UnorderedList",
  FONT_SIZE: "FONT_SIZE",
  // plugins
  SPOILER: "SPOILER",
  LINK: "LINK",
  HEADINGS: "HEADINGS",
  TEXT_COLOR: "TEXT_COLOR",
  TEXT_HIGHLIGHT: "TEXT_HIGHLIGHT",
  CODE_BLOCK: "CODE_BLOCK",
  UNDO: "UNDO",
  REDO: "REDO",
  LINE_SPACING: "LINE_SPACING",
  INCREASE_INDENT: "INCREASE_INDENT",
  DECREASE_INDENT: "DECREASE_INDENT"
});
const INSERT_PLUGIN_BUTTONS = Object.freeze({
  IMAGE: "ImagePlugin_InsertButton",
  GALLERY: "GalleryPlugin_InsertButton",
  POLLS: "Poll",
  DIVIDER: "DividerPlugin_InsertButton",
  HTML: "HTMLCodePlugin_InsertButton",
  VIDEO: "VideoPlugin_InsertButton",
  INSTAGRAM: "Instagram_InsertButton",
  YOUTUBE: "YouTube_InsertButton",
  TIKTOK: "TikTok_InsertButton",
  TWITTER: "Twitter_InsertButton",
  PINTEREST: "Pinterest_InsertButton",
  FACEBOOK: "Facebook_InsertButton",
  STORES: "Stores_InsertButton",
  EVENTS: "Events_InsertButton",
  BOOKINGS: "Bookings_InsertButton",
  BUTTON: "ButtonPlugin_InsertButton",
  CODE_BLOCK: "CodeblockPlugin_InsertButton",
  SOUND_CLOUD: "SoundcloudPlugin_InsertButton",
  GIF: "GIFPlugin_InsertButton",
  MAP: "MapPlugin_InsertButton",
  // DEPRECATED
  FILE: "UploadFilePlugin_InsertButton",
  EMOJI: "EmojiPlugin_InsertButton",
  UNDO: "UndoPlugin_InsertButton",
  REDO: "RedoPlugin_InsertButton",
  TABLE: "TablePlugin_InsertButton",
  COLLAPSIBLE_LIST: "CollapsibleList_InsertButton",
  ADSENSE: "AdSensePlugin_InsertButton",
  AUDIO: "AudioPlugin_InsertButton",
  SPOTIFY: "Spotify_InsertButton"
});
const BUTTON_TYPES = Object.freeze({
  BUTTON: "button",
  FILE: "file",
  MODAL: "modal",
  CUSTOM_BLOCK: "custom-block",
  SEPARATOR: "SEPARATOR",
  DROPDOWN: "DROPDOWN",
  GROUP: "GROUP"
});

export { BUTTON_TYPES, CHARACTERS, FORMATTING_BUTTONS, INSERT_PLUGIN_BUTTONS, KEYS_CHARCODE, TEXT_TYPES };
//# sourceMappingURL=consts.js.map
